import React from "react";
import {connect} from "react-redux";
import {Alert, Button, Form, Input, message, Modal, Select, Space, Table, Tooltip} from "antd";
import {displayErrors} from "../../libs/utils";
import {cloneSoftware, loadSoftwareCloneEligibleDomains} from "../../actions/domains";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import QuestionCircleOutlined from "@ant-design/icons/lib/icons/QuestionCircleOutlined";

class SoftwareCloneModal extends React.Component {
    state = {
        domainsList: [],
        loadingDomains: false,
        domainsLoaded: false,
        domains: [],
        loading: false,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.loadingDomains && !this.state.domainsLoaded) {
            this.setState({ loadingDomains: true });

            this.props.loadSoftwareCloneEligibleDomains(this.props.domain, (res) => {
                this.setState({ loadingDomains: false, domainsLoaded: true, domains: res.data });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                    this.setState({ loadingDomains: false, domainsLoaded: true });
                }
            });
        }
    }

    closeModal = () => {
        if(this.state.loading) return;

        this.setState({
            domainsList: [],
            loadingDomains: false,
            domainsLoaded: false,
            domains: [],
            loading: false,
        }, () => this.props.close())
    }

    cloneSoftware = () => {
        if(this.state.domainsList.length === 0) {
            return message.error('Please select at least one target domain!');
        }

        let data = {
            domains: this.state.domainsList.map((domain) => {
                return { domain: domain.domain, protocol: domain.protocol, install_dir: domain.install_dir };
            }),
        }

        this.setState({ loading: true });

        this.props.cloneSoftware(this.props.domain, data, () => {
            this.setState({ loading: false }, () => {
                message.success('Software clone process successfully scheduled!');
                this.closeModal();
                this.props.loadOverview();
            });

        }, (err) => {
            if(typeof err.response!== 'undefined') {
                displayErrors(err.response.data);
            }

            this.setState({ loading: false });
        })
    }

    selectDomains = (domains) => {
        if(this.state.domainsList.length >= 10) {
            return message.error('You can select up to 10 target domains!');
        }

        let domainsList = domains.map((domain) => {
            let data = this.state.domains.find((item) => item.guid === domain);
            return { domain_name: data.domain, domain: domain, protocol: 'https://', install_dir: '' }
        });

        this.setState({ domainsList })
    }

    removeDomain = (domain) => {
        let domainsList = this.state.domainsList.filter((d) => d.domain !== domain);
        this.setState({ domainsList })
    }

    changeProtocol = (protocol, domain) => {
        let domainsList = this.state.domainsList.map((d) => {
            if(d.domain === domain) {
                return {...d, protocol: protocol };
            }

            return d;
        });

        this.setState({ domainsList })
    }

    changeInstallDir = (path, domain) => {
        let domainsList = this.state.domainsList.map((d) => {
            if(d.domain === domain) {
                return {...d, install_dir: path };
            }

            return d;
        });

        this.setState({ domainsList })
    }

    render() {
        const { Option } = Select;

        const columns = [
            { title: <span>Domain <Tooltip title='The domain where software is cloned'><QuestionCircleOutlined /></Tooltip></span>, dataIndex: 'domain_name' },
            { title: <span>Protocol <Tooltip title='Protocol for the cloned software'><QuestionCircleOutlined /></Tooltip></span>, dataIndex: 'protocol', width: '120px', render: (item, record) => <Select onChange={(value) => this.changeProtocol(value, record.domain)} style={{width: '120px'}} value={item}>
                    <Option value='http://'>http://</Option>
                    <Option value='https://'>https://</Option>
                    <Option value='http://www'>http://www</Option>
                    <Option value='https://www'>https://www</Option>
                </Select> },
            { title: <span>Directory <Tooltip title='Directory where software is cloned'><QuestionCircleOutlined /></Tooltip></span>, dataIndex: 'install_dir', width: '200px', render: (item, record) => <Input placeholder='Leave empty for root' onChange={(e) => this.changeInstallDir(e.target.value, record.domain)} />},
            { title: '', align: 'right', width: '35px', render: (item, record) => <Button danger size='small' onClick={() => this.removeDomain(record.domain)} icon={<DeleteOutlined />} />}
        ]

        return(
            <Modal
                title='Clone Software Installation'
                open={this.props.showModal}
                width={700}
                footer={<Space>
                    <Button disabled={this.state.loading} onClick={() => this.closeModal()}>Close</Button>
                    <Button disabled={this.state.loading || this.state.domainsList.length === 0}
                            loading={this.state.loading} type='primary'
                            onClick={() => this.cloneSoftware()}>Clone</Button>
                </Space>}
                onCancel={() => this.closeModal()}>
                <p><Alert type='info' showIcon message='Software can only be cloned between domains within the same hosting account.' /></p>
                <Form layout='vertical'>
                    <Form.Item label='Select up to 10 target domains'>
                        <Select
                            style={{width: '100%'}}
                            disabled={this.state.loadingDomains}
                            mode="multiple"
                            value={this.state.domainsList.map((item) => item.domain)}
                            loading={this.state.loadingDomains}
                            filterOption={(input, option) => {
                                if(typeof option !== 'undefined') {
                                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }
                                return false;
                            }}
                            onChange={(value) => this.selectDomains(value)}>
                            {this.state.domainsLoaded && this.state.domains.map((domain, index) => {
                                return <Option key={index} value={domain.guid}>{domain.domain}</Option>;
                            })}
                        </Select>
                    </Form.Item>
                </Form>
                <Table columns={columns} size='small' rowKey={domain => domain.domain} pagination={false} dataSource={this.state.domainsList} />
            </Modal>
        );
    }
}

export default connect(null, { loadSoftwareCloneEligibleDomains, cloneSoftware })(SoftwareCloneModal);